import { Component, LOCALE_ID, inject } from '@angular/core';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormControl, ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'app-language-selector',
  standalone: true,
  imports: [MatSelectModule, MatFormFieldModule, ReactiveFormsModule],
  templateUrl: './language-selector.component.html',
  styleUrl: './language-selector.component.scss'
})
export class LanguageSelectorComponent {

  locales = [
    { code: 'en', name: 'English' },
    { code: 'de', name: 'Deutsch' },
    { code: 'sv', name: 'Svenska' },
    { code: 'es', name: 'Español' },
  ];

  public activeLocale: string = inject(LOCALE_ID);

  readonly selectedLocale = new FormControl('');

  constructor() {
    this.selectedLocale.setValue(this.activeLocale);
  }

  onLanguageSelect() {
    window.location.href = `/${this.selectedLocale.getRawValue()}/index.html`;
  }
}


